import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import UserPageSlider from "./UserPageSlider";
import UserSideBar from "../../common/UserSidebar/UserSideBar";
import { getBranches } from "../../redux/branchSlice";

const UserPageDiscover = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  
  // Redux store'dan branch verilerini alıyoruz
  const { branches, loading, error } = useSelector((state) => state.branches);
  
  // Seçilen branch ID'sini takip etmek için state ekledik
  const [selectedBranchId, setSelectedBranchId] = useState(null);
  
  // Component mount edildiğinde branch verilerini çek
  useEffect(() => {
    dispatch(getBranches());
  }, [dispatch]);

  const scrollToBranchSection = (branchId) => {
    const el = document.getElementById(`branch-section-${branchId}`);
    if (el) {
      const offset = 80; // navbar yüksekliği
      const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  // URL'den branch parametresini al ve kaydır
  useEffect(() => {
    const branchId = searchParams.get('branch');
    if (branchId && branches && branches.length > 0) {
      const branchExists = branches.some(b => b._id === branchId);
      if (branchExists) {
        setSelectedBranchId(branchId);
        setTimeout(() => {
          scrollToBranchSection(branchId);
        }, 100);
      }
    }
  }, [searchParams, branches]);

  // Branch butonlarına tıklandığında çağrılacak fonksiyon
  const handleBranchClick = (branchId) => {
    setSelectedBranchId(branchId);
    scrollToBranchSection(branchId);
  };

  return (
    <>
        

    <div className="flex flex-col lg:flex-row w-full p-2 mt-[-20px]">
        {/* Sidebar */}
        <div className="flex-shrink-0">
          <UserSideBar />
        </div>

        {/* Right Side */}
        <div className="flex-1 min-w-0">
          {/* Branches Buttons */}
          <div className="mt-[45px]">
            <h1 className="text-[28.3px] text-primary font-normal font-poppins mb-2">
              {t('Branches')}
            </h1>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 sm:gap-4 w-full">
              {loading ? (
                <p>Yükleniyor...</p>
              ) : error ? (
                <p className="text-red-500">Hata: {error}</p>
              ) : branches && branches.length > 0 ? (
                branches.map((branch) => (
                  <button
                    key={branch._id}
                    className={`px-4 py-2 bg-background rounded-[50px] font-poppins text-[16px] text-primary font-bold flex items-center justify-center 
                      ${selectedBranchId === branch._id ? 'ring-2 ring-primary ring-offset-2' : ''} 
                      hover:bg-[#E5D3DD] transition-all duration-300`}
                    onClick={() => handleBranchClick(branch._id)}
                  >
                    <span>{branch.name}</span>
                  </button>
                ))
              ) : (
                <p>Şube bulunamadı.</p>
              )}
            </div>
          </div>

          {/* Slider */}
          <UserPageSlider selectedBranchId={selectedBranchId} />
        </div>
      </div>
    </>
  );
};

export default UserPageDiscover;